import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import {
  DateFormatter,
  DateTimeFormatter,
  MMYYYYFormatter,
} from "../../../common/DateFormatterWithZone";
import { Datepicker } from "../../../common/Datepicker";
import CheckboxRenderer from "../component/gainloss-system-variance-checkbox-renderer";
import SmartSelectClearable from "../../../common/SmartSelectClearable";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import "./gainloss-system-variance-screen.scss";
import RestEndPoint from "../../../common/RestEndPoint";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExport,
  faSearch,
  faSave,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import AuditModal from "./gainloss-system-variance-screen-audit-modal";
import { ColorFormatter } from "../../../common/ColorFormatter";
import { formatDecimalValue } from "../../../common/NumberFormatter";
import {
  DecimalFormatter2Digits,
  DecimalFormatter4Digits,
} from "../../../common/NumberFormatter";
import { Modal, Button } from "react-bootstrap";

const GainLossSystemVarianceScreen = inject("GainLossSystemVarianceDataStore")(
  observer((props) => {
    const { CommonStore, GainLossSystemVarianceDataStore } = props;
    const {
      screenColumnDefinitions,
      getDistricts,
      getProductionMonths,
      districts,
      productionMonths,
      jurisdiction,
      district,
      productionMonth,
      setJurisdiction,
      setDistrict,
      setProductionMonth,
      getSystemVarianceData,
      saveSystemVarianceData,
      rowData,
      setRowData,
      setAuditPopUp,
    } = props.GainLossSystemVarianceDataStore;

    let colDef = screenColumnDefinitions["GainLossSystemVarianceScreen"];
    const [modalState, setModalState] = useState({
      isModalVisible: false,
      content: "",
    });
    const [isGridVisible, setIsGridVisible] = useState(false);
    const [gridOptions] = useState({
      newRowNotSaved: false,
      rowSelection: "multiple",
      pagination: false,
      stopEditingWhenGridLosesFocus: true,
      autoSizeAllColumns: true,
      floatingFilter: true,
      enableRangeSelection: true,
      rowGroupPanelShow: "always",
      suppressContextMenu: true,
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agAggregationComponent",
            statusPanelParams: {
              aggFuncs: ["avg", "count", "min", "max", "sum"],
            },
          },
        ],
      },
      sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
          },
        ],
        showToolPanel: false,
      },
      defaultColDef: {
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      frameworkComponents: {
        SmartSelectClearable: SmartSelectClearable,
        booleanCellEditor: CheckboxRenderer,
        dateFormatter: DateFormatter,
        dateTimeFormatter: DateTimeFormatter,
        monthYearFormatter: MMYYYYFormatter,
        datePicker: Datepicker,
        ColorFormatter: ColorFormatter,
        decimalFormatter: DecimalFormatter2Digits,
        decimalFormatter4Digits: DecimalFormatter4Digits,
      },
    });

    const setColumnDef = async () => {
      const parentScreenName = props.path.split("/").pop();
      const currentScreen = props.CommonStore.screenDetails.filter(
        (x) => x.screen.name === parentScreenName
      );
      await GainLossSystemVarianceDataStore.setColumnDef(
        currentScreen,
        CommonStore
      );
    };

    const getJurisdictions = () => {
      const userRoles = RestEndPoint.getCurrentUserRoles();
      if (userRoles.includes("GainLossAdminRole")) {
        return [
          { value: "Plains - North", label: "Plains - North" },
          { value: "Plains - South", label: "Plains - South" },
        ];
      } else if (
        userRoles.includes("GainLossNorthDataEntryRole") ||
        userRoles.includes("GainLossNorthDistrictSignOffRole")
      ) {
        return [{ value: "Plains - North", label: "Plains - North" }];
      } else if (
        userRoles.includes("GainLossSouthDataEntryRole") ||
        userRoles.includes("GainLossSouthDistrictSignOffRole")
      ) {
        return [{ value: "Plains - South", label: "Plains - South" }];
      } else {
        return [];
      }
    };

    const formatExportValues = (params) => {
      switch (params?.column?.colId) {
        case "LastSavedDateTime":
        case "SourceSystemLoadDateTime":
          return params?.value
            ? moment(params?.value).format("MM/DD/YYYY h:mm a")
            : "";
        case "ProductionMonth":
          return params?.value ? moment(params?.value).format("MM/YYYY") : "";

        // case "AfterShrinkageGainLossPercent":
        // case "UnidentifiedGainLossPercent":
        // //return `${formatDecimalValue(params?.value, 2, true, true)}%`; //Two decimal places, can be negative - with percent sign
        // case "Tolerance":
        // case "Offset":
        // case "GainLossPercent":
        //   return formatDecimalValue(params?.value, 4); //Four decimal places, can be negative - with percent sign
        // //return `${formatDecimalValue(params?.value, 4, true, true)}%`; //Four decimal places, can be negative - with percent sign
        // case "Throughput":
        // case "GainLoss":
        // case "AfterShrinkageGainLoss":
        // case "UnidentifiedGainLoss":
        //   return formatDecimalValue(params?.value, 2);
        // //return formatDecimalValue(params?.value, 2, true, true); //Two decimal places, can be negative
        case "ShowFieldVarianceReport":
        case "ShowFieldVarianceExplanationReport":
        case "ShowFinancialReport":
        case "ShowSeniorManagementReport":
          return params?.value === "Yes" ? "Y" : "N";
        default:
          return params?.value;
      }
    };

    const exportToExcel = () => {
      const parentScreenName = props.path.split("/").pop();
      var today = new Date();
      const formattedDate = moment(today).format("YYYYMMDDhhmmss");
      const currentSheet = parentScreenName;
      let fileNameExcelExport =
        currentSheet + "_Export_All_" + formattedDate + "";

      gridOptions.api.exportDataAsExcel({
        fileName: fileNameExcelExport,
        sheetName: currentSheet,
        processCellCallback: formatExportValues,
      });
    };

    const handleSave = async () => {
      let systemVarianceData = rowData;
      const currentDate = new Date().toLocaleString(
        "en-US",
        { hour12: false },
        {
          timeZone: "America/Denver",
          timeZoneName: "short",
        }
      );
      const loggedInUser = RestEndPoint.getCurrentUserName();
      const updatedData = systemVarianceData
        .filter((item) => item.isModified)
        ?.map((item) => ({
          ...item,
          ProductionMonth: productionMonth?.value,
          FieldVarianceComment: item.FieldVarianceComment ?? "",
          FieldVarianceExplanationCommnet:
            item.FieldVarianceExplanationCommnet ?? "",
          FinancialComment: item.FinancialComment ?? "",
          SeniorManagementComment: item.SeniorManagementComment ?? "",
          updatedBy: loggedInUser,
          updatedDate: currentDate,
          ShowFieldVarianceExplanationReport:
            item.ShowFieldVarianceExplanationReport === "Yes",
          ShowFieldVarianceReport: item.ShowFieldVarianceReport === "Yes",
          ShowFinancialReport: item.ShowFinancialReport === "Yes",
          ShowSeniorManagementReport: item.ShowSeniorManagementReport === "Yes",
        }));
      if (updatedData?.length > 0) {
        await saveSystemVarianceData(CommonStore, updatedData);
        refreshData();
      }
    };

    const clearFilters = () => {
      gridOptions.api.setSortModel(null);
      gridOptions.api.setFilterModel(null);
      gridOptions.api.onFilterChanged();
      gridOptions.columnApi.setPivotColumns([]);
      gridOptions.columnApi.setPivotMode(false);
    };

    const refreshData = async () => {
      setRowData([]);
      await GainLossSystemVarianceDataStore.getSystemVarianceData(CommonStore);
      gridOptions.api.refreshCells();
    };

    const onCellValueChanged = (e) => {
      if (e.newValue !== null && e.oldValue != e.newValue) {
        gridOptions.api.refreshCells();
      } else {
        e.node.setDataValue(e.colDef.field, e.oldValue);
        gridOptions.api.refreshCells();
      }
      e.node.setDataValue("isModified", true);
      e.node.data.isModified = true;
      e.node.setDataValue("isNewRow", !e?.node.data.SystemVarianceId);
      e.node.data.isNewRow = !e?.node.data.SystemVarianceId;
    };

    const getHeaderName = (column, jurisdiction) => {
      switch (column?.field) {
        case "Throughput":
          return jurisdiction === "Plains - North"
            ? "Throughput - (m3)"
            : "Throughput - (bbl)";
        case "GainLoss":
          return jurisdiction === "Plains - North"
            ? "Gain/(Loss) - (m3)"
            : "Gain/(Loss) - (bbl)";
        case "WithinTolerance":
          return jurisdiction === "Plains - North"
            ? "Tolerance"
            : "Tolerance";
        case "Division":
          return jurisdiction === "Plains - North" ? "District" : "Division";
        default:
          return column?.headerName;
      }
    };

    const setHeaderNames = (jurisdiction) => {
      const columnDefs = colDef;
      columnDefs.forEach((item) => {
        item.headerName = getHeaderName(item, jurisdiction);
      });
      gridOptions.api.setColumnDefs(columnDefs);
    };

    const handleJurisdictionChange = (option) => {
      setIsGridVisible(false);
      setJurisdiction(option);
      setDistrict({ label: "Select...", value: null });
      setRowData([]);
      getDistricts(CommonStore, option?.value);
      setIsGridVisible(true);
    
      const columnsToShow = [
        "Offset",
        "Tolerance",
        "AfterShrinkageGainLoss",
        "AfterShrinkageGainLossPercent",
        "UnidentifiedGainLoss",
        "UnidentifiedGainLossPercent",
      ];
    
      gridOptions.columnApi.setColumnsVisible(columnsToShow, true);
      gridOptions.columnApi.setColumnVisible("Offset", false);
    
      setHeaderNames(option?.value);
    };

    const resetData = () => {
      setRowData([]);
      setJurisdiction({ label: "Select...", value: null });
      setDistrict({ label: "Select...", value: null });
    };

    const handleCellClicked = ({ column, value }) => {
      if (column?.colId === "FieldVarianceComment") {
        setModalState({ isModalVisible: true, content: value });
      }
    };

    useEffect(() => {
      resetData();
      const fetchData = async () => {
        await setColumnDef();
        await getProductionMonths(CommonStore);
        setIsGridVisible(true);
      };
      fetchData();
    }, []);

    const getContextMenuItems = (e) => {
      const { CommonStore, GainLossSystemVarianceDataStore } = props;
      var result = [
        {
          name: "Show Audit Data",
          action: async () => {
            const auditData =
              await GainLossSystemVarianceDataStore.getAuditData(
                CommonStore,
                e.node.data
              );
            setAuditPopUp(true);
          },
        },
      ];
      return result;
    };

    const getShowAuditPopUp = () => {
      const { showAuditPopUp } = GainLossSystemVarianceDataStore;
      return showAuditPopUp;
    };

    return (
      <div className="system-variance-screen col-md-12">
        <div className="container cb-title-container">
          <h3 className="cb-title">{"System Variance Screen"}</h3>
        </div>
        <div className="col-md-12 filters-container">
          <div className="filter-container">
            <div className="dropdown-label">{"Jurisdiction"}</div>
            <Select
              className="jurisdiction-dropdown dropdown"
              options={getJurisdictions()}
              value={jurisdiction}
              onChange={handleJurisdictionChange}
            />
          </div>
          <div className="filter-container">
            <div className="dropdown-label">{"District/Division"}</div>
            <Select
              className="district-division-dropdown dropdown"
              options={districts}
              value={district}
              onChange={(option) => setDistrict(option)}
            />
          </div>
          <div className="filter-container">
            <div className="dropdown-label production-month-label">
              {"Production Month"}
            </div>
            <Select
              className="production-month-dropdown dropdown"
              options={productionMonths}
              value={productionMonth}
              onChange={(option) => setProductionMonth(option)}
            />
          </div>
          <div className="filter-container">
            <button
              type="search"
              className="btn btn-primary btn-grid active"
              aria-expanded="false"
              disabled={!jurisdiction || !district || !productionMonth}
              onClick={() => getSystemVarianceData(CommonStore)}
            >
              <FontAwesomeIcon icon={faSearch} className={"fa-icon"} />
              <span>Search</span>
            </button>
          </div>
        </div>
        {isGridVisible && (
          <div className="col-md-12 table-container">
            <div
              id={"gainloss-system-variance"}
              style={{ width: "100%" }}
              className="col-md-12 ag-fresh"
            >
              <div
                className="ag-theme-balham grid-container"
                style={{
                  font: ".8em Segoe UI, sans-serif",
                  margin: "15px",
                }}
              >
                <AgGridReact
                  gridID={"system-variance"}
                  gridOptions={gridOptions}
                  columnDefs={colDef}
                  rowData={rowData}
                  onCellValueChanged={onCellValueChanged}
                  suppressContextMenu={false}
                  getContextMenuItems={getContextMenuItems}
                  enableBrowserTooltips={true}
                  onCellClicked={handleCellClicked}
                ></AgGridReact>
              </div>
            </div>
            <div className={"toolbar"}>
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                onClick={handleSave}
                disabled={rowData?.length <= 0}
              >
                <FontAwesomeIcon className={"fa-icon"} icon={faSave} />
                <span>Save</span>
              </button>
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                onClick={() => {
                  clearFilters();
                  refreshData();
                }}
                disabled={rowData?.length <= 0}
              >
                <FontAwesomeIcon className={"fa-icon"} icon={faSync} />
                <span>Refresh / Cancel</span>
              </button>
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                onClick={exportToExcel}
                disabled={rowData?.length <= 0}
              >
                <FontAwesomeIcon className={"fa-icon"} icon={faFileExport} />
                <span>Export</span>
              </button>
              {getShowAuditPopUp() && <AuditModal />}
              {modalState?.isModalVisible && (
                <Modal
                  className="field-variance-comment-modal"
                  show={modalState?.isModalVisible}
                  onHide={() =>
                    setModalState({ isModalVisible: false, content: "" })
                  }
                >
                  <Modal.Header>
                    <Modal.Title>Field Variance Comment</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="comment-content">{modalState?.content}</div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() =>
                        setModalState({ isModalVisible: false, content: "" })
                      }
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
            </div>
          </div>
        )}
      </div>
    );
  })
);

export default GainLossSystemVarianceScreen;
